export default "__VITE_ASSET__CXc886yn__"